<div class="ck-panel">


  <!-- Loading indicator -->
  <div *ngIf="loading" class="message-container">
    <div i18n="@@invoice.validation.loading">Loading invoice validation data...</div>
  </div>

  <!-- No data message - only for truly no data -->
  <div *ngIf="!loading && !hasOriginalData" class="message-container no-data">
    <div i18n="@@invoice.validation.noData">No validation data available</div>
  </div>

  <!-- Status header and tabs - show when we have original data -->
  <div class="ck-panel-body" *ngIf="!loading && hasOriginalData">
    <!-- Status header -->
    <div class="status-container">
      <h3 [class]="getStatusClass(overallStatus)">
        <span class="material-icons-outlined">
          {{ getStatusIcon(overallStatus) }}
        </span>
        <span i18n="@@invoice.validation.title">Invoice Transaction Validation</span>
      </h3>
    </div>

    <!-- Filter tabs -->
    <div class="filter-tabs">
      <div class="nav nav-tabs" role="tablist">
        <button type="button" 
                class="nav-link" 
                [class.active]="currentFilter === TimesheetFilter.All"
                data-filter="all"
                (click)="onFilterChange(TimesheetFilter.All)"
                i18n="@@invoice.validation.filter.all">
          All
        </button>
        <button type="button" 
                class="nav-link" 
                [class.active]="currentFilter === TimesheetFilter.Unavailable"
                data-filter="unavailable"
                (click)="onFilterChange(TimesheetFilter.Unavailable)"
                i18n="@@invoice.validation.filter.unavailable">
          Unavailable
        </button>
        <button type="button" 
                class="nav-link" 
                [class.active]="currentFilter === TimesheetFilter.Missing"
                data-filter="missing"
                (click)="onFilterChange(TimesheetFilter.Missing)"
                i18n="@@invoice.validation.filter.missing">
          Missing
        </button>
      </div>
    </div>

    <!-- Filter results messages - show below tabs when no results for current filter -->
    <div *ngIf="workOrderValidations.length === 0 && isFiltered" class="message-container no-data">
      <div class="filter-no-results">
        <div *ngIf="currentFilter === TimesheetFilter.Unavailable" 
             i18n="@@invoice.validation.noUnavailable">No unavailable timesheets found</div>
        <div *ngIf="currentFilter === TimesheetFilter.Missing" 
             i18n="@@invoice.validation.noMissing">No missing timesheets found</div>
      </div>
    </div>

    <!-- Workers & Work Orders - show when we have filtered results -->
    <div class="ck-accord" *ngIf="workOrderValidations.length > 0">
      <ng-container *ngFor="let workOrder of workOrderValidations; trackBy: trackByWorkOrder">
        <div class="rule-group-container">
          <div>
            <app-phx-accordion [closeOthers]="false">
              <app-phx-accordion-group #workOrderAccordion [(isOpen)]="workOrder.isExpanded" [showToggle]="false" class="group-accordion">
                
                <!-- Work Order Header -->
                <div class="ck-accord-head" accordion-heading>
                  <mat-icon [class]="getStatusClass(workOrder.workerStatus)">
                    {{ getStatusIcon(workOrder.workerStatus) }}
                  </mat-icon>
                  <span class="ck-title">
                    {{ workOrder.workerName }} <span class="ck-count">({{ workOrder.workOrderId }})</span>
                  </span>
                  <mat-icon class="expand-icon">
                    {{ workOrder.isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    <span class="cdk-visually-hidden">
                      {{ workOrder.isExpanded ? 'Collapse' : 'Expand' }}
                    </span>
                  </mat-icon>
                </div>

                <!-- Work Order Items -->
                <div class="ck-accord-body" accordion-body>
                  <div *ngFor="let item of workOrder.items; trackBy: trackByItem" class="ck-rule">
                    <mat-icon [class]="getStatusClass(item.status)">
                      {{ getStatusIcon(item.status) }}
                    </mat-icon>
                    <div class="ck-text">
                      <span>{{item.text}}</span>
                    </div>
                  </div>
                </div>

              </app-phx-accordion-group>
            </app-phx-accordion>
          </div>
        </div>
      </ng-container>
    </div>

  </div>

  <!-- Loading state -->
  <div class="loading-container" *ngIf="loading">
    <app-bouncing-balls color="#333"></app-bouncing-balls>
  </div>
</div>
